import { ITrackMutationForm, ITrackResponse, TRACK_CENSORIOUS } from 'services/tracks/types';

export const trackQueryToForm = (trackQuery: ITrackResponse): ITrackMutationForm => {
  const { trackStatus, instrumental,language, ...track } = {
    ...trackQuery,
    status: trackQuery.trackStatus,
    isInstrumental: trackQuery.instrumental,
    assignIsrc: trackQuery.isrc === null,

    pline: trackQuery.pline?.name?.length ? trackQuery.pline : { name: '', year: '' },
    cline: trackQuery.cline?.name?.length ? trackQuery.cline : { name: '', year: '' },
    artists: trackQuery.artists?.map(({ rolePlacement, ...artist }) => ({
      ...artist,
    })),
    statistics: { startSettlementPeriodId: '', endSettlementPeriodId: '' },
    censorious: trackQuery.censorious ?? TRACK_CENSORIOUS.unknown,
    genre:
      trackQuery.genre !== null && trackQuery.genre.id !== -1
        ? { id: trackQuery.genre.id, name: trackQuery.genre.name }
        : { id: -1, name: '' },
  };

  return track;
};
